// extracted by mini-css-extract-plugin
export default {"favorites":"Favorites_favorites__qsZUE","center":"Favorites_center__u947O"};